import styled from "styled-components";
import {GameJackpotDefaultBox} from "./game-jackpot.default.box";

export const GameJackpotSIBox = styled(GameJackpotDefaultBox)`
  border-left: solid 5px ${props => props.theme.colors.brandPrimary};
  border-top-left-radius: 2px;
  border-bottom-left-radius: 2px;
  padding-left: 3px;
`